import { Ctrl } from ":mods";
import { For } from "solid-js";
import { ROUTES } from "../const";

export function TopAnchores(props: Ctrl.Nav.model.TopNavJSXItemProps) {
  const routes = [
    {
      title: "About",
      to: ROUTES.about,
    },
    {
      title: "Stages",
      to: ROUTES.courses,
    },
    {
      title: "Delivery Teams",
      to: ROUTES.teams,
    },
    {
      title: "Course Schedule",
      to: ROUTES.schedules,
    },
    {
      title: "Jobs",
      to: ROUTES.jobs,
    },
    {
      title: "Blog",
      to: ROUTES.blog,
    },
    {
      title: "Contact Us",
      to: ROUTES.contact,
    },
  ];
  return (
    <nav class="flex flex-row w-full h-full justify-end items-center space-x-6 children:(text-14px)">
      <For each={routes}>
        {(item) => {
          return (
            <span
              class={props.classes.anchor}
              onClick={() => {
                props.actions.navigate(item.to);
              }}
            >
              {item.title}
            </span>
          );
        }}
      </For>
    </nav>
  );
}
